module.exports = __webpack_public_path__ + "static/img/ico-payment-gwi.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ico-payment-gwi.png
// module id = 174
// module chunks = 0